import { render, staticRenderFns } from "./loyalty-details.vue?vue&type=template&id=3d0d9a14&scoped=true&lang=pug"
import script from "./loyalty-details.vue?vue&type=script&lang=js"
export * from "./loyalty-details.vue?vue&type=script&lang=js"
import style0 from "./loyalty-details.vue?vue&type=style&index=0&id=3d0d9a14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0d9a14",
  null
  
)

export default component.exports